import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';
import { querySelector } from '../../../../utils';
import queryMetaHandler from '../../../../utils/queryMetaHandler';
import omitProps from '../../../../utils/omitProps';

export const GetAllLookupLeasesQuery = gql`
  query GetAllLookupLeases($operatorId: Int, $joinType: LookupJoinTypes!, $lookupStatus: LookupStatusTypes) {
    all_leases: lookup_leases(operator_id: $operatorId, lookup_query: {join_type: $joinType, lookup_status: $lookupStatus}) {
      edges {
        node {
          id
          name
          lookupStatus: lookup_status
        }
      }
    }
  }
`;

const marshallUserData = ({ ownProps, data }) => {
  const leaseList = querySelector(data, '$.all_leases.edges[*].node', []);
  return {
    ...ownProps,
    leaseList,
    data,
  };
};

const queryOperatorData = graphql(GetAllLookupLeasesQuery, {
  props: marshallUserData,
  options: {
    fetchPolicy: 'network-only',
  },
});

export const queryLookupLeasesGQL = compose(
  queryOperatorData,
  queryMetaHandler,
  omitProps(['data']),
);
